import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { RouterModule } from '@angular/router';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';

import { SharedModule } from './../shared/shared.module';
import { CreditCardListComponent } from './components/credit-card-list/credit-card-list.component';
import { CreditCardTransactionOverviewComponent } from './components/credit-card-transaction-overview/credit-card-transaction-overview.component';
import { CreditCardsLimitOverviewComponent } from './components/credit-cards-limit-overview/credit-cards-limit-overview.component';
import { CreditCardsOverviewComponent } from './components/credit-cards-overview/credit-cards-overview.component';
import { CreditCardNamePipe } from './pipes/credit-card-name.pipe';

const CreditCardsComponents = [
  { name: 'CreditCardsOverview', type: CreditCardsOverviewComponent },
  { name: 'CreditCardsLimitOverview', type: CreditCardsLimitOverviewComponent },
  { name: 'CreditCardList', type: CreditCardListComponent },
  {
    name: 'CreditCardTransactionOverview',
    type: CreditCardTransactionOverviewComponent
  }
];

@NgModule({
  declarations: [
    CreditCardsOverviewComponent,
    CreditCardListComponent,
    CreditCardTransactionOverviewComponent,
    CreditCardsLimitOverviewComponent,
    CreditCardNamePipe
  ],
  imports: [
    SharedModule,
    CommonModule,
    JssModule,
    RouterModule,
    MatLegacyMenuModule,
    MatLegacyTooltipModule
  ]
})
export class CreditCardsModule {}

export { CreditCardsComponents };
